
import CryptoJS from "crypto-js";

// const key = CryptoJS.enc.Utf8.parse("1234567ABCDEFG");  //十六位十六进制数作为密钥
// const iv = CryptoJS.enc.Utf8.parse('ABCDEFG1234567');   //十六位十六进制数作为密钥偏移量

const CRYPTOJSKEY = "9a12100b0457ca48db65c9257a760b9c";
// 加密
const encrypt = (plaintText) => {
    var plaintText = plaintText;
    var options = {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    };
    var key = CryptoJS.enc.Utf8.parse(CRYPTOJSKEY);
    var encryptedData = CryptoJS.AES.encrypt(encodeURIComponent(JSON.stringify(plaintText)), key, options);
    var encryptedBase64Str = encryptedData.toString();
    return encryptedBase64Str;
};
//解密
const decrypt = (encryptedBase64Str) => {
    var vals = encryptedBase64Str;
    var options = {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    };
    var key = CryptoJS.enc.Utf8.parse(CRYPTOJSKEY);
    var decryptedData = CryptoJS.AES.decrypt(vals, key, options);
    var decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData);
    return decryptedStr
};

const decryptWithKey = (encryptedBase64Str, CRYPTOJSKEY) => {
    var vals = encryptedBase64Str;
    var options = {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    };
    var key = CryptoJS.enc.Utf8.parse(CRYPTOJSKEY);
    try {
        var decryptedData = CryptoJS.AES.decrypt(vals, key, options);
        return decryptedData.toString(CryptoJS.enc.Utf8).toString();
    } catch (error) {
        alert("加密数据解析错误!");
        return;
    }
}


export default {
    encrypt,
    decrypt,
    decryptWithKey,
}


// WEBPACK FOOTER //
// ./src/manager/crypto.js